import {
  TypeCodecs,
  useTypedSearchParams,
  type TypedSearchParams,
} from "../../hooks/useTypedSearchParams";
import { AccountsTable } from "./AccountsTable";

const ACCOUNT_SEARCH_PARAMS = {
  forumId: { codec: TypeCodecs.Number, name: "f.forumId" },
  id: { codec: TypeCodecs.Number, name: "f.id" },
  name: { codec: TypeCodecs.String, name: "f.name" },
} as const satisfies TypedSearchParams;

export const Accounts = () => {
  const filters = useTypedSearchParams(ACCOUNT_SEARCH_PARAMS);

  return <AccountsTable filters={filters} />;
};
